<template>
  <div class="main-section" id="info-list">
    <!-- <section class="main-section"> -->
    <h3 class="section-title green-left-head">
      お知らせ
    </h3>
    <div class="box-item">
      <div class="box-item-wrapper" v-if="news.length > 0">
        <ul class="box-item-list">
          <li
            class="box-item-list-item"
            v-for="(item, index) in news"
            :key="index"
          >
            <a
              :href="item.url"
              v-if="item.url != ''"
              :target="item.url_target ? '_blank' : ''"
              ><div class="date">
                {{ item.registration_at | moment("YYYY/MM/DD")
                }}<span v-html="createTag(item.label)"></span>
              </div>
              <div class="text">{{ item.title }}</div></a
            >
            <router-link
              :to="{ name: 'information-detail', params: { id: item._id } }"
              v-else
            >
              <div class="date">
                {{ item.registration_at | moment("YYYY/MM/DD")
                }}<span v-html="createTag(item.label)"></span>
              </div>
              <div class="text">{{ item.title }}</div>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="box-item-wrapper" v-else>
        現在、お知らせはありません。
      </div>
    </div>
    <!-- </section> -->
    <!--/.main-section-->
  </div>
</template>

<script>
import InfoService from "../services/info.service";

export default {
  name: "InfoList",
  props: ["mode"],
  data: function() {
    return {
      news: [],
    };
  },
  async mounted() {
    // console.log("list --");
    // console.log(response.data.docs);
    await this.$nextTick();
    await this.$nextTick();
    const response = await InfoService.list();
    if (response.data.docs != undefined) {
      this.news = response.data.docs;
    } else {
      this.news = [];
    }
  },
  methods: {
    createTag(tag) {
      const titles = {
        tag01: "作業予定",
        tag02: "重要",
        tag03: "書類",
        tag04: "理事会",
      };
      return `<span class="tag ${tag}">${titles[tag]}</span>`;
    },
  },
};
</script>

<style></style>
